import { p2 } from '@/lib/dom';

/** Generate CAM-{SITE}-NN candidate ids for the given sites and index range. */
export function candidates(sites: string[], idxMax: number): string[] {
  const out: string[] = [];
  for (const s of sites) for (let n = 1; n <= idxMax; n++) out.push(`CAM-${s}-${p2(n)}`);
  return out;
}
